import React, { useRef, useState, useEffect } from "react";
import aboutimg from '../image/dharajbanner.jpg';
import "./TestimonialSlider.css";
import '../App';
const testimonials = [
    {
        img: aboutimg,
        name: "Umesh",
        designation:
            "Senior General Manager – Head, Product Cost Management, Mahindra & Mahindra (AFS)",
        content: [
            "lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit ipsam ullam, error at itaque doloremque hic obcaecati perspiciatis nemo qui voluptatem modi, quo perferendis minus illum laboriosam. Modi, libero eligendi.",
        ],
    },
    {
        img: aboutimg,
        name: "Faiyag",
        designation:
            "Head of Module – EV Electrical & Electronics, CDMM, Mahindra Last Mile Mobility",
        content: [
            "lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit ipsam ullam, error at itaque doloremque hic obcaecati perspiciatis nemo qui voluptatem modi, quo perferendis minus illum laboriosam. Modi, libero eligendi.",
        ],
    },
    {
        img: aboutimg,
        name: "Anisha",
        designation:
            "Head – Human Resources, Mahindra Last Mile Mobility Ltd.",
        content: [
            "lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit ipsam ullam, error at itaque doloremque hic obcaecati perspiciatis nemo qui voluptatem modi, quo perferendis minus illum laboriosam. Modi, libero eligendi.",
        ],
    },
    {
        img: aboutimg,
        name: "Zeeshaan",
        designation:
            "Group MD, Founder & CEO, World Development Corporation",
        content: [
            "lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit ipsam ullam, error at itaque doloremque hic obcaecati perspiciatis nemo qui voluptatem modi, quo perferendis minus illum laboriosam. Modi, libero eligendi.",
        ],
    },
    {
        img: aboutimg,
        name: "Vijay",
        designation: "Senior General Manager at Mahindra and Mahindra",
        content: [
            "lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit ipsam ullam, error at itaque doloremque hic obcaecati perspiciatis nemo qui voluptatem modi, quo perferendis minus illum laboriosam. Modi, libero eligendi.",
        ],
    },
];

export default function TestimonialSlider() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const sliderRef = useRef(null);
    const wrapperRef = useRef(null);

    const getOffset = (index) => {
        const slides = sliderRef.current?.children || [];
        let offset = 0;
        for (let i = 0; i < index; i++) {
            offset += slides[i].offsetHeight;
        }
        return offset;
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
        const offset = getOffset(index);
        sliderRef.current.style.transform = `translateY(-${offset}px)`;
        updateWrapperHeight(index);
    };

    const updateWrapperHeight = (index) => {
        const slides = sliderRef.current?.children || [];
        if (slides[index]) {
            wrapperRef.current.style.height = slides[index].offsetHeight + "px";
        }
    };

    useEffect(() => {
        updateWrapperHeight(0);
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % testimonials.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        goToSlide(currentIndex);
    }, [currentIndex]);

    return (
        <section className=" py-5">
            <div className="container position-relative overlay-container">
                <div className="row justify-content-center">
                    <div className="col-md-9 col-12">
                        <div className="testimonial-section">
                            <h2 className="text-dark">What Clients Say?</h2>

                            <div className="testimonial-wrapper" ref={wrapperRef}>
                                <div className="testimonial-slider" ref={sliderRef}>
                                    {testimonials.map((t, idx) => (
                                        <div className="testimonial-slide" key={idx}>
                                            <div className="client-info">
                                                <div className="client-img">
                                                    <img src={t.img} alt={t.name} />
                                                </div>
                                                <div>
                                                    <div className="client-name text-dark">{t.name}</div>
                                                    <div className="client-designation text-dark">
                                                        {t.designation}
                                                    </div>
                                                </div>
                                            </div>
                                            {t.content.map((p, i) => (
                                                <p className="text-dark" key={i}>{p}</p>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="testimonial-dots">
                                {testimonials.map((_, i) => (
                                    <span
                                        key={i}
                                        className={`dot ${i === currentIndex ? "active" : "notActive"}`}
                                        onClick={() => goToSlide(i)}
                                    ></span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
